export default __webpack_public_path__ + "images/cdab0024e3ac1511caf4d8cafcecdc4e-national_security.jpg";